<template>
    <div>
        <div class="hidden md:block">
            <div v-for="grades in props.grades" :key="Object.keys(grades)" class="pb-0">
                <table class="w-full" :class="inlineGrades ? '' : 'border'">
                    <tr class="" :class="(inlineGrades ? 'bg-abogyellow-100' : 'bg-aboggray-100', isSticky ? 'sticky top-14' : '')">
                        <th class="p-2"></th>
                        <th v-for="gradeKey in props.gradeKeys" :key="gradeKey.Score" class="p-2">
                            <div :class="gradeKey.Type == grades[0].GradeType || gradeKey.Type == null ? '' : 'invisible'">{{ gradeKey.Description }}</div>
                        </th>
                    </tr>
                    <template v-for="grade in grades" :key="gradeCalcId(grade)">
                        <!-- <tr v-if="grade.firstCaseRow" class="border-t" :class="{ 'bg-aboggray-100': grade.caseColor }">
                        <td class="p-4" colspan="100">{{ grade.CaseDescription }}</td>
                    </tr> -->
                        <tr
                            class="border-t"
                            :class="{
                                'bg-abogred-100': grade.hasErrors,
                                'opacity-50': grade.isSaving,
                                'bg-aboggray-100': grade.caseColor,
                                // 'border-b-4': grade.CaseQuestionIndex === null && grade.GradeCustomIndex === null && i < props.grades.length - 1,
                            }"
                        >
                            <td class="p-4 w-1/3">
                                <span>{{ gradeDescription(grade) }}</span>
                            </td>
                            <td v-for="gradeKey in props.gradeKeys" :key="gradeKey.Score" class="text-center">
                                <div :class="gradeKey.Type == grades[0].GradeType || gradeKey.Type == null ? '' : 'invisible'">
                                    <i
                                        @click="setGrade(grade, gradeKey.Score)"
                                        class="my-1 p-4"
                                        :class="{
                                            'pointer-events-none': !editable,
                                            'cursor-pointer': editable,
                                            'fa fa-check': grade.Score == gradeKey.Score,
                                            'far fa-circle': grade.Score != gradeKey.Score,
                                        }"
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr v-if="props.gradeKeys && grade.Score !== null && noteRequired(grade.Score)">
                            <td :colspan="props.gradeKeys.length + 1">
                                <textarea :value="grade.Note" @change="setNote(grade, $event.target.value)" :disabled="!editable || grade.isSaving" class="border w-full p-2"></textarea>
                            </td>
                        </tr>
                    </template>
                </table>
            </div>
        </div>
        <div class="block md:hidden">
            <div v-for="grades in props.grades" :key="Object.keys(grades)">
                <div
                    v-for="(grade, i) in grades"
                    :key="gradeCalcId(grade)"
                    class="border-t flex justify-between mx-4"
                    :class="{
                        'bg-abogred-100': grade.hasErrors,
                        'opacity-50': grade.isSaving,
                        'bg-aboggray-100': grade.caseColor,
                        'border-b-4': grade.CaseQuestionIndex == null && i < grades.length - 1,
                    }"
                >
                    <div class="p-4">
                        <span>{{ gradeDescription(grade) }}</span>
                    </div>
                    <select @change="setGrade(grade, $event.target.value)" class="p-4" :disabled="!editable || grade.isSaving">
                        <option :selected="grade.Score === null" value=""></option>
                        <option
                            v-for="gradeKey in props.gradeKeys.filter((obj) => {
                                return obj.Type == grades[0].GradeType || obj.Type == null;
                            })"
                            :key="gradeKey.Score"
                            :selected="grade.Score == gradeKey.Score"
                            :value="gradeKey.Score"
                        >
                            <div>{{ gradeKey.Description }}</div>
                        </option>
                    </select>
                    <div v-if="props.gradeKeys && grade.Score !== null && noteRequired(grade.Score)" class="w-full ml-4">
                        <textarea :value="grade.Note" @change="setNote(grade, $event.target.value)" :disabled="!editable || grade.isSaving" class="border w-full p-2"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { computed } from "vue";
const props = defineProps(["gradeKeys", "grades", "editable", "inlineGrades", "sticky", "shortdesc"]);

const isSticky = computed(() => {
    if (props.sticky == undefined) {
        return true;
    } else {
        return props.sticky;
    }
});

const emit = defineEmits(["saveGrade"]);
function gradeCalcId(grade) {
    // grades might not have an id yet, so build a fake id from case & question ids
    return `${grade.CaseID}-${grade.CaseQuestionID}`;
}
function setGrade(grade, score) {
    // if score is the same assume we are "unchecking" the score
    // select inputs cannot have "null" values, so use empty string for unselected
    if (grade.Score === score || score === "") score = null;
    grade.Score = score;
    emit("saveGrade", grade);
}
function setNote(grade, note) {
    grade.Note = note;
    emit("saveGrade", grade);
}
function noteRequired(score) {
    if (!props.gradeKeys) return false;
    const key = props.gradeKeys.find((k) => k.Score == score);
    return key.NoteRequired;
}
function gradeDescription(grade) {
    if (grade.GradeCustomDescription) {
        return props.shortdesc && grade.GradeCustomDescriptionShort
            ? grade.GradeCustomDescriptionShort
            : grade.GradeCustomDescription;
    }
    // {{ grade.CaseDescription }} - {{ grade.CaseQuestionIndex !== null ? grade.CaseQuestionIndex : "Overall" }}
    return grade.CaseDescription + " - " + (grade.CaseQuestionIndex !== null ? grade.CaseQuestionIndex : "Overall");
}
</script>
